module.exports = "<ul class=list-downloads-icon> <li ng-class=attachment.class ng-repeat=\"attachment in attachments\"><a target=_blank ng-href={{attachment.downloadUrl}} download>{{attachment.title}}</a></li> </ul>";


//////////////////
// WEBPACK FOOTER
// ./web/js/module/practicalExample/js/attachments/attachments.html
// module id = 1131
// module chunks = 0